/* ============================================
   SALON DE MATCHA — Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Navigation scroll behavior ──
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Mobile menu ──
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      header && header.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileMenuClose && mobileMenu) {
    mobileMenuClose.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      header && header.classList.remove('menu-open');
      document.body.style.overflow = '';
    });
  }
  // Close mobile menu on link click
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        header && header.classList.remove('menu-open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Cart drawer ──
  const cartBtn = document.querySelector('.cart-btn');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartDrawerClose = document.querySelector('.cart-drawer-close');

  function openCart() {
    cartOverlay && cartOverlay.classList.add('open');
    cartDrawer && cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartOverlay && cartOverlay.classList.remove('open');
    cartDrawer && cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCart);

  // ── Scroll reveal ──
  const srElements = document.querySelectorAll('[data-sr]');
  if (srElements.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('revealed');
          }, i * 120);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    srElements.forEach(el => observer.observe(el));
  }

  // ── Legal page tabs ──
  const legalTabs = document.querySelectorAll('.legal-tab');
  const legalContents = document.querySelectorAll('.legal-content');

  legalTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      legalTabs.forEach(t => t.classList.remove('active'));
      legalContents.forEach(c => c.classList.remove('active'));
      tab.classList.add('active');
      const content = document.getElementById('tab-' + target);
      if (content) {
        content.classList.add('active');
        window.scrollTo({ top: content.offsetTop - 120, behavior: 'smooth' });
      }
    });
  });

  // ── Quantity selector ──
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('.qty-input');
    const minus = selector.querySelector('.qty-minus');
    const plus = selector.querySelector('.qty-plus');
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }
    if (plus) {
      plus.addEventListener('click', () => {
        const val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  // ── Language switcher (Shopify Markets redirect) ──
  const langBtns = document.querySelectorAll('.lang-btn');
  langBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const locale = btn.dataset.locale;
      if (locale) {
        // Shopify localization redirect
        const currentPath = window.location.pathname;
        const pathWithoutLocale = currentPath.replace(/^\/(ja|en|ar)/, '');
        window.location.href = '/' + locale + pathWithoutLocale + window.location.search;
      }
    });
  });

  // ── Smooth scroll for anchor links ──
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Instagram embed reload ──
  if (window.instgrm) {
    window.instgrm.Embeds.process();
  }

  // ── Cart count update (Shopify AJAX) ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const countEl = document.querySelector('.cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(() => {});
  }
  updateCartCount();

  // ── Add to cart via AJAX ──
  const addToCartForms = document.querySelectorAll('.product-form');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('.add-to-cart-btn');
      const formData = new FormData(form);
      const data = {
        id: formData.get('id'),
        quantity: formData.get('quantity') || 1
      };
      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.dataset.adding || 'Adding...';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(r => r.json())
        .then(() => {
          updateCartCount();
          openCart();
          fetchCartItems();
          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.added || 'Added!';
            setTimeout(() => {
              btn.textContent = btn.dataset.original || btn.dataset.addText || 'Add to Cart';
            }, 2000);
          }
        })
        .catch(() => {
          if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.original || 'Add to Cart';
          }
        });
    });
  });

  // ── Fetch and render cart items ──
  function fetchCartItems() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const body = document.querySelector('.cart-drawer-body');
        const subtotalEl = document.querySelector('.cart-subtotal-amount');
        if (!body) return;

        if (cart.item_count === 0) {
          body.innerHTML = '<p class="cart-empty">カートは空です / Your cart is empty</p>';
        } else {
          body.innerHTML = cart.items.map(item => `
            <div class="cart-item">
              <img class="cart-item-img" src="${item.image}" alt="${item.title}" />
              <div class="cart-item-info">
                <p class="cart-item-name">${item.product_title}</p>
                <p class="cart-item-price">${formatMoney(item.line_price)}</p>
                <p style="font-size:0.75rem;color:rgba(42,42,42,0.4);margin-top:0.25rem;">×${item.quantity}</p>
              </div>
              <button class="cart-item-remove" data-key="${item.key}" aria-label="Remove">✕</button>
            </div>
          `).join('');

          // Remove item buttons
          body.querySelectorAll('.cart-item-remove').forEach(btn => {
            btn.addEventListener('click', () => {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
              }).then(() => { updateCartCount(); fetchCartItems(); });
            });
          });
        }

        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }
      });
  }

  if (document.querySelector('.cart-drawer')) {
    fetchCartItems();
  }

  function formatMoney(cents) {
    const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'JPY';
    const amount = cents / 100;
    if (currency === 'JPY') return '¥' + Math.round(amount).toLocaleString();
    if (currency === 'QAR') return 'QAR ' + amount.toFixed(2);
    return '$' + amount.toFixed(2);
  }

});
